import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material';

import { BaseManagement } from '../../services/base-management';
import { DialogYesNoComponent } from '../dialog-yes-no/dialog-yes-no.component';
import { MultiLanguageService } from '../../services/multi-language.service';
import { PaymentService } from '../../services/payment.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { PaymentPlanService } from '../../services/payment-plan.service';
import { CardFormatterService } from '../../services/card-formatter.service';
import { Router } from '@angular/router';
import { TransactionInvoiceService } from 'src/app/pages/transaction/services/transaction-invoice.service';
import { Subscription } from 'rxjs';

declare var $: any;

interface TransactionInvoice {
  name: string;
  value: number | string;
  id: any;
};


@Component({
  selector: 'payment-plan-form',
  templateUrl: './payment-plan-form.component.html',
  styleUrls: ['./payment-plan-form.component.scss']
})
export class PaymentPlanFormComponent extends BaseManagement implements OnInit {

  subscriptions: Subscription[] = [];  
  // Forms
  form: FormGroup;

  // Transaction
  transaction: any;
  transactionInvoice: TransactionInvoice[] = [];
  paymentInfo: any;
  authNumber: any;
  installmentNumber: any;

  // Titles
  planInfoText: string;
  convenienceFeeInfoText: string;

  // payment
  paymentType: any = 'NA';
  installmentId: number;
  cardTypeChangeEvent: any;
  invoiceId: any;

  selected: any = [];

  // Conditions
  cofirmButtonDisabled: boolean = true;
  paymentCompleted: boolean = false;


  // Test
  transactionCost: number = 4000;
  subtotal: number = 4000;
  convenienceFee: number = 30;
  total: number;
  currentInstallment: number;

  constructor(
    private cardFormatterService: CardFormatterService,
    private fb: FormBuilder,
    public paymentService: PaymentService,
    public dialog: MatDialog,
    public transactionService: TransactionService,
    public multiLanguageService: MultiLanguageService,
    public translate: TranslateService,
    private currencyPipe: CurrencyPipe,
    public paymentPlanService: PaymentPlanService,
    private router: Router,
    private transactionInvoiceService: TransactionInvoiceService
  ) {
    super();

    this.form = this.fb.group(
      {
        CardNumber: ['', Validators.compose([Validators.required, Validators.minLength(17)]) ],
        Expiry: ['', Validators.compose([Validators.required, Validators.minLength(9)]) ],
        CVC: ['', Validators.compose([Validators.required])],
        CardType: ['', Validators.compose([Validators.required])],
        NameOnCard: ['', Validators.compose([Validators.required])],
        PaymentAddress: ['', Validators.compose([Validators.required])],
      },
      {
        validator: this.paymentInfoValidation
      }
    );
  }

  ngOnInit() {
    this.transaction = {...this.transactionService.itemToEdit};
    console.log(this.transaction);

    console.log(this.isSaving());


    this.startSaving('saving');

    this.paymentPlanService.getPaymentInfo( this.transaction.Id )
    .then( (data: any) => {
      this.stopSaving();
      // console.log(this.isSaving());

      this.paymentInfo = data.Data;
      this.currentInstallment = this.paymentInfo.TotalAmountInstallment + this.paymentInfo.FeeAmount;
      console.log(this.paymentInfo);

      this.transactionInvoice = [
        {
          name: this.translate.instant('payment.transactionCost'),
          value: this.currencyPipe.transform(this.paymentInfo.Subtotal, 'USD', 'symbol'),
          id: null
        },
        {
          name: this.translate.instant('payment.total'),
          value: this.currencyPipe.transform(this.paymentInfo.TotalAmount , 'USD', 'symbol'),
          id: null
        },
        {
          name: this.translate.instant('payment.userPay'),
          value: `${this.paymentInfo.InstallmentsTotal}x
                  ${this.currencyPipe.transform((this.currentInstallment), 'USD', 'symbol')}`,
          id: 1
        }
      ];

      this.translate
        .get(
          ['payment.paymentPlanInformation', 'payment.convenienceFeeInformation'],
          {
            installmentTotal: this.paymentInfo.InstallmentsTotal,
            installment:  this.currencyPipe.transform(this.paymentInfo.TotalAmountInstallment, 'USD', 'symbol'),
            convenienceFee: this.currencyPipe.transform(this.paymentInfo.FeeAmount, 'USD', 'symbol')
          }
        )
        .subscribe((translations) =>{
          this.planInfoText = translations['payment.paymentPlanInformation'];
          this.convenienceFeeInfoText = translations['payment.convenienceFeeInformation']
        });
    });

    this.cardTypeChangeEvent = this.cardFormatterService.cardTypeChangeEvent.subscribe((paymentType)=>{
      this.paymentType = paymentType;

      this.form.patchValue({
        CardType: paymentType,
      });
    });


  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  tryPay(){
    this.translate
        .get(['payment.tryPaySubmit', 'message.yes', 'message.no'])
        .subscribe( (translations) => {
          console.log(translations);


          let dialogRef = this.dialog.open(DialogYesNoComponent, {
            width: '250px',
            data: {
              msg: translations['payment.tryPaySubmit'],
              yesText: translations['message.yes'],
              noText: translations['message.no']
            }
          });

          dialogRef.afterClosed().subscribe((result: any) =>{
            if(result == 1){
              console.log(this.setupPaymentData());
              this.pay();
            }
          });

        });
  }

  formatValue(e){
    this.cardFormatterService.monitorCcFormat($(e.currentTarget));
  }

  paymentInfoValidation(control: AbstractControl) {
    let cardNumber = control.get('CardNumber').value;
    let expiry = control.get('Expiry').value;

    var pad = (num, size) => {
        num = num.toString();
        while (num.length < size) num = "0" + num;

        return num;
    };

    if(expiry.indexOf("/")>=0 && expiry.length == 9){
      let expiryArray = expiry.split('/');
      let date = new Date();

      let expiryMonth = parseInt(expiryArray[0]);
      let expiryYear = parseInt(expiryArray[1]);
      let currentMonth = date.getMonth() + 1;
      let currentYear = date.getFullYear();


      try{


      let specifiedDate = new Date(expiryYear,expiryMonth);
      let currentDate = new Date();

      expiryMonth = pad(expiryMonth, 2);
      currentMonth = pad(currentMonth, 2);
      currentYear= pad(currentYear, 4);

      if(expiryMonth > 12 || expiryMonth <= 0 ){
         this.paymentService.toggleDateFormatError = true;
      }

      console.log('specifiedDate', specifiedDate);
      console.log('currentDate', currentDate)


      if(specifiedDate<currentDate || !specifiedDate){
        control.get('Expiry').setErrors( {invalidDate: true} )
      }
      }catch(e){
        control.get('Expiry').setErrors( {invalidDate: true} )
      }
    }else{
      control.get('Expiry').setErrors( {invalidDate: true} )
    }


    return null
  }

  reloadTransactionInvoices() {
    this.startSaving('reloading-invoices');

    this.transactionInvoiceService
      .getInvoices(this.transaction.Id)
      .then((data: any) => {
        console.log('DATA', data);

        // this.setAmountToPay();

        // this.getFees();

        if (this.paymentService.invoiceToPayId == 0) {
          this.invoiceId = 0;
          if(data.length > 0){
            this.invoiceId = data[0].Id;
          }
        } else {
          this.invoiceId = this.paymentService.invoiceToPayId;
        }
        this.stopSaving();
      });
  }

  setupPaymentData() {
    let expiry = this.form.controls.Expiry.value;
    let expiryMonth = 0;
    let expiryYear = 0;

    if (expiry.indexOf('/') >= 0 && expiry.length == 9) {
      let expiryArray = expiry.split('/');
      expiryMonth = parseInt(expiryArray[0]);
      expiryYear = parseInt(expiryArray[1]);
    }

    let additionalInfo = this.form.controls.PaymentAddress.value;

    additionalInfo.NameOnCard = this.form.controls.NameOnCard.value;

    let card = this.form.controls.CardNumber.value.substr(
      this.form.controls.CardNumber.value.length - 4
    );

    additionalInfo.LastFourDigits = card;

    let data = {
      "CardType": this.form.controls.CardType.value,
      "accountNumber": this.form.controls.CardNumber.value,
      "CVV2_CVC2": this.form.controls.CVC.value,
      "expirationMonth": expiryMonth,
      "expirationYear": expiryYear,
      "name": this.form.controls.NameOnCard.value,
      "additionalInfo": JSON.stringify(additionalInfo),
      "zip": this.form.controls.PaymentAddress.value.PostalCode,
      "installmentQuantity": 1
    };

    return data;
  }

  pay(){
    if (this.isSaving()) {
      return false;
    }
    this.startSaving('payAndSubmit');
    var data = this.setupPaymentData();

    this.paymentPlanService.pay(this.transaction.Id, data)
    .then( 
      (data: any) => {
        if(data.Success === true){
          let installment = data.Data.filter( installment => installment.PaidDate !== null);
          this.installmentId = installment[0].Id;
          console.log('INSTALLMENT ID', this.installmentId);
          this.transactionService.transactionRefresher.next('refresh-all');
          this.paymentPlanService.getPaymentList( this.transaction.Id )
          .then( (data: any) => {
            console.log(data);
            this.stopSaving();
            this.authNumber = data.Data[0].AuthorizationNumber;
            this.installmentNumber = data.Data[0].InstallmentNumber;
            this.paymentCompleted = true;  
            this.paymentPlanService.paymentInfo = data.Data;
          });
        } else {
          this.stopSaving();
          this.serverError = data.Message && data.Message;
        }
      },
      (err: any) =>{
        console.log(err);  
      }
    )
        .then(
          (data: any) => {
            if(data.Success === true){
              this.transactionService.transactionRefresher.next('refresh-all');
              this.paymentPlanService.getPaymentList( this.transaction.Id )
                  .then( (data: any) => {
                    console.log(data);
                    this.stopSaving();
                    this.authNumber = data.Data[0].AuthorizationNumber;
                    this.installmentNumber = data.Data[0].InstallmentNumber;
                    this.paymentCompleted = true;
                    this.paymentPlanService.paymentInfo = data.Data;
                  });
            } else {
              this.stopSaving();
              this.serverError = data.Message && data.Message;
            }
          },
          (err: any) =>{
            console.log(err);
          }
        )

  }

  viewInvoice(){
    this.router.navigate([`/account/payments/transaction/${this.installmentId}`]);
    this.paymentService.paymentPlanFormIsVisible = false;
  }

  close() {
    this.paymentService.paymentPlanFormIsVisible = false;
  }

  backToTransaction(){
    this.paymentService.paymentPlanFormIsVisible = false;
    this.router.navigate([`/transactions/edit/${this.transaction.Id}`]);
  }


}
